module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-widgets/project-detail-widgets.component.scss
// module id = ./src/app/projects/detail/project-detail-widgets/project-detail-widgets.component.scss
// module chunks = main